module.exports = __webpack_public_path__ + "static/media/new-arrivals-logged-in.bc5fae54.jpg";